module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAUVBMVEXOzs7c3Nzc3Nzc3Nzc3NzU1NTc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3NzPz8/c3NzV1dXc3Nzc3Nzc3Nzc3NwAAADR0dHOzs7Y2NjX19fV1dXc3Nz4ZHCtAAAAFXRSTlPzPJFrI8YNQZ11YSoH6Vm+CpAGAQChWOHTAAAASklEQVR42tWOORaAIAwFg7jgAgioxNz/oJCOpbJ0ynnvL3D1/NcZfBncCndYYqa5zIo7q2ep+sKQnQr1xqgJ9nZXxrX74t359XMC0UUb0Yl27qcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_desc_disabled.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_desc_disabled.png
// module chunks = 2